<template>
  <div>
    <a-table :pagination="false" :columns="columns" :data-source="dataSource" size="small" row-key="id">
      <span slot="reviewer" slot-scope="text, record">
        <user-profiles :value="[record.reviewer.id]" avatar />
      </span>
      <span slot="result" slot-scope="text, record">
        <a-badge :status="reviewResult[record.result].status" :text="reviewResult[record.result].label" />
      </span>
      <span slot="updated_time" slot-scope="text, record">
        {{ ['pending', 'processing'].includes(record.result) ? '--/--' : record.updated_time }}
      </span>
    </a-table>
  </div>
</template>
<script>
const columns = [
  {
    key: 'id',
    title: 'ID',
    align: 'center',
    dataIndex: 'id'
  },
  {
    title: '审批项',
    align: 'center',
    key: 'description',
    dataIndex: 'description',
    customRender: (_text, _row) => {
      return _text === null ? '--/--' : _text;
    }
  },
  {
    title: '顺序',
    align: 'center',
    dataIndex: 'order',
    key: 'order'
  },
  {
    align: 'center',
    title: '签名方式',
    key: 'sign_method',
    dataIndex: 'sign_method',
    customRender: (_text, _row) => {
      return _text === 'AND' ? '会签' : '或签';
    }
  },
  {
    key: 'reviewer',
    title: '审批人',
    scopedSlots: { customRender: 'reviewer' }
  },
  {
    key: 'result',
    title: '审批状态',
    scopedSlots: { customRender: 'result' }
  },
  {
    align: 'center',
    title: '操作时间',
    key: 'updated_time',
    scopedSlots: { customRender: 'updated_time' }
  }
];
export default {
  props: {
    dataSource: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      columns,
      reviewResult: {
        pending: { label: '待处理', value: 1, status: 'default' },
        passed: { label: '通过', value: 'passed', status: 'success' },
        skipped: { label: '跳过', value: 'skipped', status: 'warning' },
        failed: { label: '不通过', value: 'failed', status: 'error' },
        processing: { label: '处理中', value: 'processing', status: 'processing' }
      }
    };
  }
};
</script>
